module.exports = __webpack_public_path__ + "static/media/item_5_3_comp.1db06127.png";